import { connect } from 'react-redux';
import PendingAccreditationRequestsList from "./PendingAccreditationRequestsList";
import { getTranslation } from "../../../reducers/common/localization";
import {getCurrentGroup} from "../../../reducers/account/role";
import {
    getAccreditationRequestsForProcessing,
    getPendingAccreditationRequestsData,
    loadingPendingAccreditationRequestsList,
    setStartAccreditationRequest,
    fetchGetAccreditationRequestsPerCountryForValidation,
    getPendingAccreditationRequestsPerCountryData,
    getPendingAccreditationRequestsCountryFilter,
    onUpdateAccreditationRequestsForValidationCountryFilter,
    clearAccreditationRequestsForValidationCountryFilter,
    getPendingAccreditationRequestsPerDomainData,
    onFetchGetAccreditationRequestsPerDomainForValidation,
    onUpdateAccreditationRequestsForValidationDomainFilter,
    getPendingAccreditationRequestsDomainFilter,
    clearAccreditationRequestsForValidationDomainFilter,
    getPendingAccreditationRequestsPerContinentData
} from '../../../reducers/accreditation/pendingAccreditationRequests';
import { isOrgBava } from '../../../reducers/organization/organization';
import {getLocationData} from '../../../reducers/common/location';

const mapStateToProps = state => {
    return {
        loading: loadingPendingAccreditationRequestsList(state),
        data: getPendingAccreditationRequestsData(state),
        group: getCurrentGroup(state),
        translation: getTranslation(state),
        isOrgBava: isOrgBava(state),
        requestsPerCountry: getPendingAccreditationRequestsPerCountryData(state),
        requestsPerDomain: getPendingAccreditationRequestsPerDomainData(state),
        requestsPerContinent: getPendingAccreditationRequestsPerContinentData(state),
        countryFilter: getPendingAccreditationRequestsCountryFilter(state),
        domainFilter: getPendingAccreditationRequestsDomainFilter(state),
        locationData: getLocationData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadAccreditationRequests: (groupId, page) => dispatch(getAccreditationRequestsForProcessing(groupId, page)),
        onStartValidation: (id) => {
            dispatch(setStartAccreditationRequest(id));
        },
        onLoadARsPerCountry: (groupId) => dispatch(fetchGetAccreditationRequestsPerCountryForValidation(groupId)),
        onLoadARsPerDomain: (groupId) => dispatch(onFetchGetAccreditationRequestsPerDomainForValidation(groupId)),
        onUpdateCountryFilter: (countryFilter) => dispatch(onUpdateAccreditationRequestsForValidationCountryFilter(countryFilter)),
        onUpdateDomainFilter: (domain) => dispatch(onUpdateAccreditationRequestsForValidationDomainFilter(domain)),
        onClearCountryFilter: () => dispatch(clearAccreditationRequestsForValidationCountryFilter()),
        onClearDomainFilter: () => dispatch(clearAccreditationRequestsForValidationDomainFilter()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingAccreditationRequestsList);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/pendingAccreditationRequestsList/PendingAccreditationRequestsList.container.js